
<template>
  <div>
     <h2 class="m-auto text-danger text-center pt-5 pb-2">Welcome Admin</h2>
      <!-- <h3 class="m-auto text-info text-center pt-3 pb-3">Let's Start</h3> -->
     <div class="container">
  <div class="row">
    <div class="col-12 col-md-8 mx-auto my-4">
      <form-wizard finish-button-text="We're there" color="#6A55C2">
        <h2 slot="title" class="text-info">Let's Start</h2> 
  <tab-content title="">
    <h4 class="text-info mb-2">Step 1</h4> 
     <h6 class="text-secondary mb-2">Go to Home Page and add a banner image of your shop.</h6>
      <h6 class="text-secondary mb-2">Then go to About Page, Here you can write a description about your shop. Also you can add an image of your team or your shop.</h6>
  </tab-content>
  <tab-content title="">
     <h4 class="text-info mb-2">Step 2</h4> 
       <h4 class="text-info mb-2">Settig Up Contact Details</h4> 
       <h6 class="text-secondary mb-2">Go to Contact Page and add the contact details of your shop.</h6>
        <!-- <h4 class="text-info mb-2">What is Latitude & Longitude?</h4>
        <h6 class="text-secondary mb-2">Latitude and Longitude are the units that represent the coordinates at geographic coordinate system. These values are necessary to show your location on Google Map. All you need to do is allow the website to access your location (You will see an alert box when the page is loaded.) and then these values will appear in the Contact Page. You can contact us, if you have any inconvenience.</h6> -->
   </tab-content>
   <tab-content title="">
      <h4 class="text-info mb-2">Step 3</h4>
       <h4 class="text-danger mb-2">Yuhuuu!</h4>  
       <h6 v-if="plan == 'Starter'" class="text-secondary mb-2">Now you can add items and offers to your <span class="text-primary">eshop.</span> Also you can SHOPiN in other eshops.</h6>
       <div v-if="plan != 'Starter'">
       <h6 class="text-secondary mb-2">Now you can add items and offers to your <span class="text-primary">eshop</span>, receive orders from customers and deliver items to them. Also you can SHOPiN in other eshops.</h6>
         <h6 class="text-secondary mb-2" v-if="items == 15">Please make sure to add minimum of {{items}} items/products in order to show your shop in the search results.</h6>
         <h6 class="text-secondary mb-2" v-if="items == 5">Please make sure to add minimum of {{items}} vehicles in order to show your shop in the search results.</h6>
         </div>
       <h6 class="text-secondary mb-2">Feel free to contact us anytime, if you have any inconvenience or need more information.</h6>

       <h4 class="text-danger mb-2">Rock Your Business - <span>Regards from eshops.lk</span></h4>  
      
   </tab-content>
</form-wizard>
</div>
</div>
<h2 class="m-auto text-info text-center mt-3 pb-2">Current Status</h2>
<div class="row mt-4">
					<div class="col-lg-3 col-xs-6">
						<div class="rad-info-box rad-txt-primary">
							<i class="fa fa-product-hunt"></i>
							<span class="heading">Current Items</span>
							<span class="value"><span>{{curProducts}}</span></span>
						</div>
					</div>
					<div class="col-lg-3 col-xs-6">
						<div class="rad-info-box rad-txt-primary">
							<i class="fa fa-shopping-bag"></i>
							<span class="heading">Current Offers</span>
							<span class="value"><span>{{curOffers}}</span></span>
						</div>
					</div>
					<div class="col-lg-3 col-xs-6">
						<div class="rad-info-box rad-txt-danger">
							<i class="fa fa-product-hunt"></i>
							<span class="heading">Maximum Items</span>
							<span class="value"><span v-if="plan != 'Starter'">{{maxProducts}}</span>
              <span v-if="plan == 'Starter'">25</span></span>
						</div>
					</div>
					<div class="col-lg-3 col-xs-6">
						<div class="rad-info-box rad-txt-danger">
							<i class="fa fa-shopping-bag"></i>
							<span class="heading">Maximum Offers</span>
							<span class="value"><span>10</span></span>
						</div>
					</div>
				</div>
    <div class="row mt-4">
					<div class="col-lg-6 col-xs-6" v-if="plan == 'Premium' || plan ==  'Enterprise'">
						<div class="rad-info-box rad-txt-violet">
							<i class="fa fa-truck"></i>
							<span class="heading">Current Orders</span>
							<span class="value"><span>{{orders}}</span></span>
						</div>
					</div>
					<div class="col-lg-6 col-xs-6">
						<div class="rad-info-box rad-txt-violet">
							<i class="fa fa-eye"></i>
							<span class="heading">Store Views</span>
							<span class="value"><span>{{visits}}</span></span>
						</div>
					</div>
  </div>
  <h2 v-if="plan != 'Starter'" class="m-auto text-info text-center pt-4 pb-2">Categories</h2>
  <div class="row mt-4 mx-auto" v-if="plan != 'Starter'">
		<div class=" col-12 col-md-6 mx-auto mb-m-7">
      <chartjs-doughnut class="mx-auto" v-if="showchart" :scalesdisplay="false" :width="width" :height="height" :labels="mylabels"
      :datasets="mydatasets"></chartjs-doughnut>
		</div>
  </div>  
</div>

  </div>
</template>

<script>
import firebase from 'firebase/app'
import db from "../../config/FirebaseInit"
// import Vue from "vue";
// import "hchs-vue-charts";
// import "chart.js";
export default {
  name: 'dashboard',
 data(){
   return{
     shops:[],
     plan:'',
     items:'',
     curProducts:'',
      maxProducts:'',
     curOffers:'',
     visits:'',
     orders:'',
      showchart:false,
      width:300,
      height:400,
     mylabels: [],
     mydata:[],
        mydatasets:[{
            data: [],
            backgroundColor: [
                "#04B404",
                "#FF8000",
                "#FA5858",
                "#FA5882",
                "#F781BE",
                "#2E9AFE",
                "#FF0040",
                "#A901DB",
                "#81F781",
                "#FF00BF",
                "#2EFEF7",
                "#0101DF",
                "#80FF00",
                "#B40404",
                "#81DAF5",	
                "#FF6384",
                "#36A2EB",
                "#FFCE56",
               
            ],
            hoverBackgroundColor: [
                "#D8D8D8",
                 "#D8D8D8",
                  "#D8D8D8",
                   "#D8D8D8",
                    "#D8D8D8",
                     "#D8D8D8",
                      "#D8D8D8",
                       "#D8D8D8",
                        "#D8D8D8",
                         "#D8D8D8",
                          "#D8D8D8",
                           "#D8D8D8",
                            "#D8D8D8",
                             "#D8D8D8",
                              "#D8D8D8",
                               "#D8D8D8",
                                "#D8D8D8",
                                 "#D8D8D8",
                
            ]
        }]
   }
 },

 created(){
    if(screen.width > 575){
        this.width = 250,
        this.height = 350
      }
   db.collection('shops').where("owner", "==", firebase.auth().currentUser.uid)
      .get().then(querySnapshot => {
        
      querySnapshot.forEach(doc => {
        const data = {
      'id' : doc.id,
      'plan':doc.data().plan,
       'cat':doc.data().cat,
       'curOffers':doc.data().curOffers,
        'curProducts':doc.data().curProducts,
        'maxProducts':doc.data().maxProducts,
        'visits':doc.data().visits,
      'orders': doc.data().orders,
      'catValues':doc.data().catValues
        }
		this.shops.push(data)
    this.orders = this.shops[0].orders
    this.curProducts = this.shops[0].curProducts
    this.maxProducts = this.shops[0].maxProducts
    this.curOffers = this.shops[0].curOffers
    this.visits = this.shops[0].visits
    this.plan = this.shops[0].plan
    this.mylabels = Object.keys(this.shops[0].catValues)
    this.mydatasets[0]['data'] = Object.keys(this.shops[0].catValues).map(k => this.shops[0].catValues[k])
    console.log('this.mylabels',this.mylabels)
    console.log('this.mydata',this.mydatasets[0]['data'])
    this.showchart = true
    if(this.cat == 'Vehicles'){
      this.items = 5
    }else{
      this.items = 15
    }
	  })
	  })
 }
  
}
</script>

<style scoped>
.rad-info-box {
  margin-bottom: 16px;
  box-shadow: 1px 1px 2px 0 #CCCCCC;
  padding: 20px;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);
  background: white !important;
}

.rad-info-box i {
  display: block;
  background-clip: padding-box;
  margin-right: 15px;
  height: 60px;
  width: 60px;
  border-radius: 100%;
  line-height: 60px;
  text-align: center;
  font-size: 3.4em;
  position: absolute;
}

.rad-info-box .value,
.rad-info-box .heading {
  display: block;
  position: relative;
  color: #515d6e;
  text-align: right;
  z-index: 10;
}

.rad-info-box .heading {
  font-size: 1.2em;
  font-weight: 300;
  text-transform: uppercase;
}

.rad-info-box .value {
  font-size: 2.1em;
  font-weight: 600;
  margin-top: 5px;
}
.rad-txt-primary {
  color: #1C7EBB;
}

.rad-bg-primary {
  background: #1C7EBB;
}

.rad-txt-success {
  color: #23AE89;
}

.rad-bg-success {
  background: #23AE89;
}

.rad-txt-danger {
  color: #E94B3B;
}

.rad-bg-danger {
  background: #E94B3B;
}

.rad-txt-warning {
  color: #F98E33;
}

.rad-bg-warning {
  background: #F98E33;
}

.rad-txt-violet {
  color: #6A55C2;
}

.rad-bg-violet {
  background: #6A55C2;
}
@media (max-width: 575px){
  .mb-m-7{
    margin-left: -7px !important ;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/admin/Dashboard.vue